<template>
  <div>
    <Head :title="`${form.name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/routes">Маршруты</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-full" label="Название" />
          <text-input v-model="form.departure" :error="form.errors.departure" class="pb-8 pr-6 w-full lg:w-1/2" label="Пункт отправления" />
          <text-input v-model="form.destination" :error="form.errors.destination" class="pb-8 pr-6 w-full lg:w-1/2" label="Пункт назначения" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Описание" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить маршрут</loading-button>
        </div>
      </form>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <div class="mb-8 w-full">
          <strong>Точки: </strong> {{ route.point_count }}
        </div>
      </div>
    </div>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/points">Точки на маршруте</Link>
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">№</th>
          <th class="pb-4 pt-6 px-6">Название</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Время</th>
        </tr>
        <tr v-for="(point, pointIndex) in route.points" :key="point.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/points/${point.id}/edit`">
              {{ pointIndex +1 }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/points/${point.id}/edit`">
              {{ point.name }}
              <icon v-if="point.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            {{ point.pivot.time_to }}
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/routes/${route.id}/points/${point.id}/detach`" tabindex="-1">
              <icon name="trash" class="block w-6 h-6 fill-red-800" />
            </Link>
          </td>
        </tr>
        <tr v-if="route.point_count === 0">
          <td class="px-6 py-4 border-t" colspan="4">Точек нет</td>
        </tr>
      </table>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <form @submit.prevent="addPoint">
        <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
          <select-input v-model="routePointForm.point_id" :error="routePointForm.errors.point_id" class="pb-8 pr-6" label="Точка">
            <option :value="null" />
            <option v-for="point in points" :key="point.id" :value="point.id">{{ point.name }}</option>
          </select-input>
          <text-input v-model="routePointForm.time_to" :error="routePointForm.errors.time_to" class="pb-8 pr-6" label="Время до точки" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="routePointForm.processing" class="btn-indigo ml-auto" type="submit">Добавить</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import Icon from '@/Shared/Icon'

export default {
  components: {
    TextareaInput,
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    route: Object,
    points: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.route.name,
        destination: this.route.destination,
        departure: this.route.departure,
        description: this.route.description,
      }),

      routePointForm: this.$inertia.form({
        point_id: '',
        time_to: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/routes/${this.route.id}`)
    },
    addPoint() {
      this.routePointForm.post(`/routes/${this.route.id}/points`)
    },
    removePoint(id) {
      this.get(`/routes/${this.route.id}/points/${id}/detach`)
    },
    restore() {
      if (confirm('Вы уверены что хотите восстановить маршрут?')) {
        this.$inertia.put(`/routes/${this.route.id}/restore`)
      }
    },
  },
}
</script>
